<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter301youwin">CHAPTER 301 - YOU WIN</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter302comewithmetoaplace">CHAPTER 302 - COME WITH ME TO A PLACE</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter303aviewofherback">CHAPTER 303 - A VIEW OF HER BACK</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter304hewasborninthemidstofbliss">CHAPTER 304 - HE WAS BORN IN THE MIDST OF BLISS</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter305dontsaynevereasily">CHAPTER 305 - DON'T SAYNEVER EASILY</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter306nannyfickforonenightbenotsocheap">CHAPTER 306 - NANNY FICK FOR ONE NIGHT BE NOT SO CHEAP</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter307twotigers">CHAPTER 307 - TWO TIGERS</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter308fourmenatableofmahjong">CHAPTER 308 - FOUR MEN A TABLE OF MAHJONG</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter309youarehisrightfulwife" title="Link target outside of Sample">CHAPTER 309 - YOU ARE HIS RIGHTFUL WIFE</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter310illegitimatechild" title="Link target outside of Sample">CHAPTER 310 - ILLEGITIMATE CHILD?</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter311reunion" title="Link target outside of Sample">CHAPTER 311 - REUNION</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter312dontdrinkforfearofpoisoning" title="Link target outside of Sample">CHAPTER 312 - DON'T DRINK FOR FEAR OF POISONING!</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter313becauseiloveyou" title="Link target outside of Sample">CHAPTER 313 - BECAUSE I LOVE YOU</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter314cantchaseawoman" title="Link target outside of Sample">CHAPTER 314 - CAN'T CHASE A WOMAN</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter315areyouitchy" title="Link target outside of Sample">CHAPTER 315 - ARE YOU ITCHY</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter316tolivehappilytogether" title="Link target outside of Sample">CHAPTER 316 - TO LIVE HAPPILY TOGETHER?</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter317youcanonlyhavemeinyoureyes" title="Link target outside of Sample">CHAPTER 317 - YOU CAN ONLY HAVE ME IN YOUR EYES!</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter318everythingisuptoyou" title="Link target outside of Sample">CHAPTER 318 - EVERYTHING IS UP TO YOU</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter319itsalluptofate" title="Link target outside of Sample">CHAPTER 319 - IT'S ALL UP TO FATE</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter320yoursafetyismoreimportant" title="Link target outside of Sample">CHAPTER 320 - YOUR SAFETY IS MORE IMPORTANT</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter321hesmybrother" title="Link target outside of Sample">CHAPTER 321 - HE'S MY BROTHER</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter322youaretheonethatpeopletalkaboutwhentheyarestupid" title="Link target outside of Sample">CHAPTER 322 - YOU ARE THE ONE THAT PEOPLE TALK ABOUT WHEN THEY ARE STUPID</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter323dontbeafraidimoutside" title="Link target outside of Sample">CHAPTER 323 - DON'T BE AFRAID I'M OUTSIDE</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter324imissyou" title="Link target outside of Sample">CHAPTER 324 - I MISS YOU</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter325ialsowanttolivehere" title="Link target outside of Sample">CHAPTER 325 - I ALSO WANT TO LIVE HERE</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter326ifwemisseachotherwemisseachother" title="Link target outside of Sample">CHAPTER 326 - IF WE MISS EACH OTHER WE MISS EACH OTHER</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter327nanaisalreadypregnantwithxischild" title="Link target outside of Sample">CHAPTER 327 - NANA IS ALREADY PREGNANT WITH XI'S CHILD</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter328youactuallycalledthepolice" title="Link target outside of Sample">CHAPTER 328 - YOU ACTUALLY CALLED THE POLICE!</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter329hesmysonsfatherbibi" title="Link target outside of Sample">CHAPTER 329 - HE'S MY SON'S FATHER BIBI</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter330themoremymotherinlawsawhersoninlawthemoreshelikedhim" title="Link target outside of Sample">CHAPTER 330 - THE MORE MY MOTHER-IN-LAW SAW HER SON-IN-LAW THE MORE SHE LIKED HIM</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter331stillangry" title="Link target outside of Sample">CHAPTER 331 - STILL ANGRY?</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter332imabadwoman" title="Link target outside of Sample">CHAPTER 332 - I'M A BAD WOMAN</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter333imgoingtotamealittlewildhorse" title="Link target outside of Sample">CHAPTER 333 - I'M GOING TO TAME A LITTLE WILD HORSE</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter334theresultoftheappraisalbecomeout" title="Link target outside of Sample">CHAPTER 334 - THE RESULT OF THE APPRAISAL BE COME OUT</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter335thereissurprise" title="Link target outside of Sample">CHAPTER 335 - THERE IS SURPRISE</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter336imtryingtogetyoupregnant" title="Link target outside of Sample">CHAPTER 336 - I'M TRYING TO GET YOU PREGNANT</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter337didyoufeelgoodwatchingthemthrowdogfoodaround" title="Link target outside of Sample">CHAPTER 337 - DID YOU FEEL GOOD WATCHING THEM THROW DOG FOOD AROUND?</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter338areyousureyouwanttodrinkwithme" title="Link target outside of Sample">CHAPTER 338 - ARE YOU SURE YOU WANT TO DRINK WITH ME?</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter339whydidyourunintomyheart" title="Link target outside of Sample">CHAPTER 339 - WHY DID YOU RUN INTO MY HEART</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter340inevitablymanypeoplehavealongnightssleep" title="Link target outside of Sample">CHAPTER 340 - INEVITABLY MANY PEOPLE HAVE A LONG NIGHT'S SLEEP</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter341cantyoubemoregentle" title="Link target outside of Sample">CHAPTER 341 - CAN'T YOU BE MORE GENTLE?</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter342stalkingsurveillance" title="Link target outside of Sample">CHAPTER 342 - STALKING SURVEILLANCE</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter343keeferslife" title="Link target outside of Sample">CHAPTER 343 - KEEFER'S LIFE</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter344youdbetterstayinthispositionallthetime" title="Link target outside of Sample">CHAPTER 344 - YOU'D BETTER STAY IN THIS POSITION ALL THE TIME!</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter345areyoupregnant" title="Link target outside of Sample">CHAPTER 345 - ARE YOU PREGNANT?</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter346marrymebemywife" title="Link target outside of Sample">CHAPTER 346 - MARRY ME BE MY WIFE</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter347youareademon" title="Link target outside of Sample">CHAPTER 347 - YOU ARE A DEMON</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter348dowhatyouhavetodo" title="Link target outside of Sample">CHAPTER 348 - DO WHAT YOU HAVE TO DO</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter349ifyoudonotcherishitletitgo" title="Link target outside of Sample">CHAPTER 349 - IF YOU DO NOT CHERISH IT LET IT GO!</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter350anotheroneappeared" title="Link target outside of Sample">CHAPTER 350 - ANOTHER ONE APPEARED</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter351thismustbeacompositepicture" title="Link target outside of Sample">CHAPTER 351 - THIS MUST BE A COMPOSITE PICTURE</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter352bigbrothersarmwillalwaysletyouleanon" title="Link target outside of Sample">CHAPTER 352 - BIG BROTHER'S ARM WILL ALWAYS LET YOU LEAN ON</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter353iwontletanythinghappentoyou" title="Link target outside of Sample">CHAPTER 353 - I WON'T LET ANYTHING HAPPEN TO YOU!</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter354itsallyourfault" title="Link target outside of Sample">CHAPTER 354 - IT'S ALL YOUR FAULT!</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter355youwantmetowashitforyou" title="Link target outside of Sample">CHAPTER 355 - YOU WANT ME TO WASH IT FOR YOU?</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter356imgoingtousemyultimatemove" title="Link target outside of Sample">CHAPTER 356 - I'M GOING TO USE MY ULTIMATE MOVE</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter357myauntishere" title="Link target outside of Sample">CHAPTER 357 - MY AUNT IS HERE</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter358lijunxiyouvehadenough" title="Link target outside of Sample">CHAPTER 358 - LI JUNXI YOU'VE HAD ENOUGH!</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter359theevilwomanisonhim" title="Link target outside of Sample">CHAPTER 359 - THE EVIL WOMAN IS ON HIM</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter360becauseiloveyou" title="Link target outside of Sample">CHAPTER 360 - BECAUSE I LOVE YOU</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter361shameonyou" title="Link target outside of Sample">CHAPTER 361 - SHAME ON YOU</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter362areyounotgoingtosaveme" title="Link target outside of Sample">CHAPTER 362 - ARE YOU NOT GOING TO SAVE ME?</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter363areyoureallygoingtoplaymetodeath" title="Link target outside of Sample">CHAPTER 363 - ARE YOU REALLY GOING TO PLAY ME TO DEATH?</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter364ihaveavideo" title="Link target outside of Sample">CHAPTER 364 - I HAVE A VIDEO</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter365youknowthegiftiwant" title="Link target outside of Sample">CHAPTER 365 - YOU KNOW THE GIFT I WANT</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter366lijunxiyouarereallydespicable" title="Link target outside of Sample">CHAPTER 366 - LI JUNXI YOU ARE REALLY DESPICABLE!</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter367thepeopleinthevicinityaretheoneswhobringdisasteruponthemselves" title="Link target outside of Sample">CHAPTER 367 - THE PEOPLE IN THE VICINITY ARE THE ONES WHO BRING DISASTER UPON THEMSELVES</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter368didyougetaburninyourhead" title="Link target outside of Sample">CHAPTER 368 - DID YOU GET A BURN IN YOUR HEAD?</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter369aslongasyoureokaythatsfine" title="Link target outside of Sample">CHAPTER 369 - AS LONG AS YOU'RE OKAY THAT'S FINE!</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter370iamlijunxinothinghardtocomeby" title="Link target outside of Sample">CHAPTER 370 - I AM LI JUNXI NOTHING HARD TO COME BY!</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter371illcarryyouonmyback" title="Link target outside of Sample">CHAPTER 371 - I'LL CARRY YOU ON MY BACK</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter372idontcare" title="Link target outside of Sample">CHAPTER 372 - I DON'T CARE</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter373dontbecheapandbeagoodboy" title="Link target outside of Sample">CHAPTER 373 - DON'T BE CHEAP AND BE A GOOD BOY</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter374monstershowyoureallwrong" title="Link target outside of Sample">CHAPTER 374 - MONSTER SHOW YOU'RE ALL WRONG!</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter375stuckintoshowfieldwithoutregret" title="Link target outside of Sample">CHAPTER 375 - STUCK INTO SHOW FIELD WITHOUT REGRET!</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter376tooheartpiercing" title="Link target outside of Sample">CHAPTER 376 - TOO HEART-PIERCING</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter377menopauseoldman" title="Link target outside of Sample">CHAPTER 377 - MENOPAUSE OLD MAN</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter378soontobesoninlaw" title="Link target outside of Sample">CHAPTER 378 - SOON-TO-BE SON-IN-LAW</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter379isthattoproposetome" title="Link target outside of Sample">CHAPTER 379 - IS THAT TO PROPOSE TO ME?</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter380youdonthavetoputinsomucheffortdoyou" title="Link target outside of Sample">CHAPTER 380 - YOU DON'T HAVE TO PUT IN SO MUCH EFFORT DO YOU</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter381asyouwishbrotherinlaw" title="Link target outside of Sample">CHAPTER 381 - AS YOU WISH BROTHER-IN-LAW!</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter382loveisconsistent" title="Link target outside of Sample">CHAPTER 382 - LOVE IS CONSISTENT</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter383couldhebetryingtosellmeout" title="Link target outside of Sample">CHAPTER 383 - COULD HE BE TRYING TO SELL ME OUT?</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter384ididntexpectyoutobesodespicable" title="Link target outside of Sample">CHAPTER 384 - I DIDN'T EXPECT YOU TO BE SO DESPICABLE!</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter385youdbetterkeepyourpromise" title="Link target outside of Sample">CHAPTER 385 - YOU'D BETTER KEEP YOUR PROMISE!</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter386twoflowerstwomen" title="Link target outside of Sample">CHAPTER 386 - TWO FLOWERS TWO MEN</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter387whichdoyoulikebetter" title="Link target outside of Sample">CHAPTER 387 - WHICH DO YOU LIKE BETTER?</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter388somethingshappened" title="Link target outside of Sample">CHAPTER 388 - SOMETHING'S HAPPENED!</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter389iamthefatherofthechild" title="Link target outside of Sample">CHAPTER 389 - I AM THE FATHER OF THE CHILD</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter390begoodanddontbesad" title="Link target outside of Sample">CHAPTER 390 - BE GOOD AND DON'T BE SAD</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter391ahithurts" title="Link target outside of Sample">CHAPTER 391 - AH IT HURTS!</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter392foolishgirlitsnotlikeimblamingyou" title="Link target outside of Sample">CHAPTER 392 - FOOLISH GIRL IT'S NOT LIKE I'M BLAMING YOU</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter393heisactingandyouhavebeendupedbyhim" title="Link target outside of Sample">CHAPTER 393 - HE IS ACTING AND YOU HAVE BEEN DUPED BY HIM!</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter394alienationandintimacy" title="Link target outside of Sample">CHAPTER 394 - ALIENATION AND INTIMACY</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter395youdidntdie" title="Link target outside of Sample">CHAPTER 395 - YOU DIDN'T DIE?</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter396areyougoingtoforceamarriage" title="Link target outside of Sample">CHAPTER 396 - ARE YOU GOING TO FORCE A MARRIAGE?</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter397areyoustayingtonight" title="Link target outside of Sample">CHAPTER 397 - ARE YOU STAYING TONIGHT?</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter398whatelseistherethatihaventseenbefore" title="Link target outside of Sample">CHAPTER 398 - WHAT ELSE IS THERE THAT I HAVEN'T SEEN BEFORE?</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter399youdonthavetowashthat" title="Link target outside of Sample">CHAPTER 399 - YOU DON'T HAVE TO WASH THAT</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter400hewasjusttryingtoscareyou" title="Link target outside of Sample">CHAPTER 400 - HE WAS JUST TRYING TO SCARE YOU</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0587b5b5